
articles.classy.controller({
   name: 'articlesController',
   inject: ['$scope', '$rootScope', 'authServiceFactory'],
   init: function()
   {
   }

});

